import React from 'react';
import Products from '../../Models/Products';
import { Link } from 'react-router-dom';
import { Image } from './Image';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import StarRatingComponent from 'react-star-rating-component';
import StarRatings from 'react-star-ratings';
// 'http://127.0.0.1/sharework_back_v2/public/assets/images/products/73f1a4f2-1017050.jpeg'
import {withTranslation} from "react-i18next";
import Common from "../../Models/Common";

class Service extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            service: [],
            stars: 0,
            ind: 0
        };
        // this.getServiceTop();
    }
    componentDidMount() {
        Products.getService().then(res => {
            this.setState({ service: res.data.payload })
            // this.state.service = res.data.payload
        })
        console.log(this.state.service)
    }

    rating(stars)
    {
        // this.setState({ ind: parseFloat(stars) })
        this.state.ind = parseFloat(stars)
        console.log(this.state.ind)
        return(
            <div class="col-6 text-right pr-0">
                <StarRatings
                    rating={this.state.ind}
                    starDimension="20px"
                    starSpacing="5px"
                    starRatedColor="#FFD700"
                />
            </div>
        )
    }
    ratingSmall(stars)
    {
        // this.setState({ ind: stars })
        this.state.ind = parseFloat(stars)
        console.log(this.state.ind)
        return(
            <div class="col-6 text-right pr-0">
                <StarRatings
                    rating={this.state.ind}
                    starDimension="10px"
                    starSpacing="3px"
                    starRatedColor="#FFD700"
                />
            </div>
        )
    }


    render() {
        const { t } = this.props;
        return(
            <div>
                {(() => {
                    if (this.state.service === null) {
                        return (
                            <div></div>
                        )
                    } else {
                        const isMobile = window.innerWidth <= 500;
                        if (isMobile) {
                            return (
                                <div>
                                    {this.state.service.map(group =>
                                         <div className="top_page_cards_mobile mb-5" style={{marginTop: "28px"}} key={group.id}>
                                            <div className="top_page_cards_mobile">
                                                <Link to={{
                                                    pathname: `/categories-details/${group.id}`,
                                                    state: { id: group.id }
                                                }} style={{ fontSize: '10px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                                    <Image style={{height: "350px"}} img={group.img} ></Image>
                                                </Link>
                                                <div className="categories_grid_text cut-content-resize m-2">
                                                    <Link to={{
                                                        pathname: `/categories-details/${group.id}`,
                                                        state: { id: group.id }
                                                    }} style={{ fontSize: '13px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                                        {group.top_title}
                                                    </Link>
                                                </div>
                                                <div className="categories_grid_text cut-content-resize m-2">
                                                    <div><span style={{fontSize: "10px"}}>{group.short_desc}</span></div>
                                                </div>
                                                <div className="categories_grid_text cut-content-resize row m-2">
                                                    <div class="col-6 text-left pl-0"><span style={{fontSize: "10px"}}>{parseInt(group.price)} {this.props.t('GLOBAL.YEN')}</span></div>
                                                    {this.ratingSmall(group.stars)}
                                                </div>
                                                <div className="categories_grid_text row m-0 mb-4 mt-1">
                                                    <div className="categories_grid_seller col-12 p-0 cut-content-resize text-center" >
                                                        <span style={{fontSize: "10px", color: "gray"}}>
                                                            <Link to={{
                                                                pathname: `/my-profile-view/users/${group.seller_id}`,
                                                            }}>
                                                                <img style={{width: "20px", height: "20px", borderRadius: "50%"}} src={Common.baseUrl+group.seller_img} />
                                                            </Link>
                                                        </span>&nbsp;
                                                        <span style={{fontSize: "10px", color: "gray"}}>
                                                            <Link to={{
                                                                pathname: `/my-profile-view/users/${group.seller_id}`,
                                                            }} style={{ fontSize: "10px", color: "gray" }}>
                                                                {group.seller_short_name}
                                                            </Link>
                                                        </span>
                                                    </div>
                                                </div>
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    )}
                                    <div className="text-center">
                                        <Link to={{
                                            pathname: `/categories/1`,
                                            state: { id: 1 }
                                        }} >{this.props.t('GLOBAL.SEE_MORE')}</Link>
                                    </div>
                                </div>
                            )
                        } else {
                            return (
                                <div>
                                    {this.state.service.map(group =>
                                         <div className="top_page_cards mb-5" style={{marginTop: "28px"}} key={group.id}>
                                            <div className="top_page_cards">
                                                <Link to={{
                                                    pathname: `/categories-details/${group.id}`,
                                                    state: { id: group.id }
                                                }} style={{ fontSize: '10px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                                    <Image style={{height: "350px"}} img={group.img} ></Image>
                                                </Link>
                                                <div className="categories_grid_text cut-content-resize m-4">
                                                    <Link to={{
                                                        pathname: `/categories-details/${group.id}`,
                                                        state: { id: group.id }
                                                    }} style={{ fontSize: '25px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                                        {group.top_title}
                                                    </Link>
                                                </div>
                                                <div className="categories_grid_text cut-content-resize m-4">
                                                    <div><span style={{fontSize: "18px"}}>{group.short_desc}</span></div>
                                                </div>
                                                <div className="categories_grid_text cut-content-resize row m-4">
                                                    <div class="col-6 text-left pl-0"><span style={{fontSize: "18px"}}>{parseInt(group.price)} {this.props.t('GLOBAL.YEN')}</span></div>
                                                    {this.rating(group.stars)}
                                                </div>
                                                <div className="categories_grid_text row m-0 mb-4 mt-1">
                                                    <div className="categories_grid_seller col-12 p-0 cut-content-resize text-center" >
                                                        <span style={{fontSize: "15px", color: "gray"}}>
                                                            <Link to={{
                                                                pathname: `/my-profile-view/users/${group.seller_id}`,
                                                            }}>
                                                                <img style={{width: "40px", height: "40px", borderRadius: "50%"}} src={Common.baseUrl+group.seller_img} />
                                                            </Link>
                                                        </span>&nbsp;
                                                        <span style={{fontSize: "15px", color: "gray"}}>
                                                            <Link to={{
                                                                pathname: `/my-profile-view/users/${group.seller_id}`,
                                                            }} style={{ fontSize: "15px", color: "gray" }}>
                                                                {group.seller_short_name}
                                                            </Link>
                                                        </span>
                                                    </div>
                                                </div>
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    )}
                                    <div className="text-center">
                                        <Link to={{
                                            pathname: `/categories/1`,
                                            state: { id: 1 }
                                        }} >{this.props.t('GLOBAL.SEE_MORE')}</Link>
                                    </div>
                                </div>
                            )
                        }
                    }
                })()}
            </div>
        )
    }
}

export default withTranslation('global')(Service);
